import { WebConfig } from '~/config/shopConfig'

const showWinterEdition = (webConfig: WebConfig) => {
  const now = new Date()
  const startDate = new Date(webConfig.winterEditionStart)
  const endDate = new Date(webConfig.winterEditionEnd)
  return now > startDate && now < endDate
}

export default showWinterEdition
